import React, { useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";

export const HeroSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: false,
    });
  }, []);

  return (
    <section className="py-5 text-center" style={{ backgroundColor: "#ffffff" }}>
      <Container>
        {/* Badge */}
        <Row className="justify-content-center mb-4">
          <Col xs="auto">
            <div
              className="d-flex align-items-center gap-2 px-3 py-2"
              data-aos="fade-up"
              style={{
                background: "#ffffff",
                borderRadius: "100px",
                border: "1px solid #fff",
                boxShadow:
                  "0px 2px 10px rgba(28,28,28,0.08), inset 0 -6px 6px rgba(255,255,255,0.2)",
              }}
            >
              <span className="text-dark" style={{ fontSize: 14 }}>
                Explore the world's greatest literature; thoughtfully curated and beautifully presented.
              </span>
            </div>
          </Col>
        </Row>

        {/* Heading */}
        <Row className="justify-content-center mb-3">
          <Col xs={12} md={10} lg={8}>
            <h1
              className="fw-semibold"
              data-aos="fade-up"
              data-aos-delay="100"
              style={{
                fontSize: "2.5rem",
                lineHeight: "1.2",
                background:
                  "linear-gradient(180deg, #121212, rgba(18,18,18,0.7))",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              The Global Literature Showcase
            </h1>
          </Col>
        </Row>

        {/* Subheading */}
        <Row className="justify-content-center mb-4">
          <Col xs={12} md={10} lg={7}>
            <p
              className="text-muted fs-5"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              Discover the voices of humanity through a clean, minimalist lens.
            </p>
          </Col>
        </Row>

        {/* Buttons */}
        <Row
          className="justify-content-center g-3"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <Col xs="auto">
            <Button
              href="/literary"
              // target="_blank"
              // rel="noopener noreferrer"
              className="px-4 py-2"
              style={{
                backgroundColor: "#1c1c1c",
                color: "#fff",
                borderRadius: "16px",
                border: "none",
                boxShadow:
                  "inset 0 0 20px rgba(255,255,255,0.15), 0 15px 30px rgba(0,0,0,0.25)",
                fontWeight: 600,
              }}
            >
               Visit Literary 
            </Button>
          </Col>

          <Col xs="auto">
            <Button
              variant="light"
              href="/about-us"
              className="px-4 py-2"
              style={{
                borderRadius: "16px",
                border: "1px solid #fff",
                boxShadow:
                  "0px 2px 10px rgba(28,28,28,0.12), inset 0 -6px 6px rgba(255,255,255,0.2)",
                fontWeight: 600,
              }}
            >
              Know More
            </Button>
          </Col>
        </Row>
      </Container>

      {/* Responsive adjustments */}
      <style>{`
        @media (max-width: 768px) {
          h1 {
            font-size: 2rem !important;
          }
          p.fs-5 {
            font-size: 1rem !important;
          }
        }
        @media (max-width: 480px) {
          .d-flex.align-items-center.gap-2 {
            flex-direction: column;
            gap: 4px !important;
          }
        }
      `}</style>
    </section>
  );
};
